import * as TemplateAPI from '../api/template-management.api'
import { destroyItemTemplate, newItemTemplate, updateItemTemplate } from '../slice/template.slice'

export const getProjectTemplates = () => {
  return (dispatch, getState) => {
    return TemplateAPI.getProjectTemplatesAPI()
  }
}

export const addProjectTemplate = (data, id) => {
  return (dispatch, getState) => {
    return TemplateAPI.addProjectTemplateAPI(data, id)
  }
}

export const getTaskTemplates = (id) => {
  return (dispatch, getState) => {
    return TemplateAPI.getTaskTemplatesAPI(id)
  }
}

export const addTaskTemplate = (data) => {
  return (dispatch, getState) => {
    return TemplateAPI.addTaskTemplateAPI(data)
  }
}

export const editTaskTemplate = (id, data) => {
  return (dispatch, getState) => {
    return TemplateAPI.editTaskTemplateAPI(id, data)
  }
}

export const deleteTaskTemplate = (id) => {
  return (dispatch, getState) => {
    return TemplateAPI.deleteTaskTemplateAPI(id)
  }
}

export const getItemTemplates = ({ id, search = '', offset = '', limit = '', category = '', materialIssues = '' } = {}) => {
  return (dispatch, getState) => {
    return TemplateAPI.getItemTemplatesAPI({ id, search, offset, limit, category, materialIssues });
  };
};

export const getExistingItemTemplate = (data) => {
  return (dispatch, getState) => {
    return TemplateAPI.getExistingItemTemplateAPI(data)
  }
}

export const addItemTemplate = (data) => {
  return (dispatch, getState) => {
    return TemplateAPI.addItemTemplateAPI(data).then(response => {
      dispatch(newItemTemplate(response));
      return response;
    })
  }
}

export const editItemTemplate = (id, data) => {
  return (dispatch, getState) => {
    return TemplateAPI.editItemTemplateAPI(id, data).then(response => {
      dispatch(updateItemTemplate(response));
      return response;
    })
  }
}

export const deleteItemTemplate = (id) => {
  return (dispatch, getState) => {
    return TemplateAPI.deleteItemTemplateAPI(id).then(response => {
      if (response?.id)
        dispatch(destroyItemTemplate(response?.id))
    })
  }
}

export const updateTaskTemplateMaterials = (data, configs = {}) => {
  return (dispatch, getState) => {
    return TemplateAPI.updateTaskTemplateMaterialsAPI(data, configs)
  }
}

export const updateItemTemplateMaterials = (data, configs = {}) => {
  return (dispatch, getState) => {
    return TemplateAPI.updateItemTemplateMaterialsAPI(data, configs)
  }
}
export const deleteTaskTemplateItem = (id) => {
  return (dispatch, getState) => {
    return TemplateAPI.deleteTaskTemplateItemAPI(id).then(response => {
      return response;
    })
  }
}
